import { IconCheck } from 'base/ui/icons';
import { menuDivider, menuItem } from 'base/ui/menu_model';
import { FeatureFlagsStore, FLAG_KEYS } from 'blocks/flag_overrides';
import React from 'react';

export const flagsMenu = (flags: FeatureFlagsStore) => {
  return [
    ...FLAG_KEYS.map((k) => {
      const v = flags.get(k);
      const override = flags.overrides.get(k);

      return menuItem({
        label: k,
        onClick: () => flags.updateOverride(k, !v),
        iconRight: v ? (
          <div style={{ opacity: override ? 1 : 0.3 }}>
            <IconCheck />
          </div>
        ) : null,
      });
    }),
    menuDivider(),
    menuItem({
      label: 'Reset to defaults',
      onClick: () => flags.clearAllOverrides(),
    }),
  ];
};
